"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.DialogContainer = styled_components_1.default.div `
  display: inline-block;
  border: 2px solid rgb(128, 128, 128);
  border-radius: 3px;

  ${({ useFixedWidth = true }) => useFixedWidth && `width: 400px;`}

  text-align: center;

  margin: 10px 0 10px 0;
`;
//# sourceMappingURL=dialog-container.js.map